import { xhr } from '@services/http/xhr';

export const logout = (): Promise<void> => {
  return xhr.post(`/auth/logout`, {});
};